import styled from 'styled-components'
import Image from 'common/image'
import { useTranslation } from 'react-i18next'
import HKJCLogo from 'assets/HKJCLogo.svg'
import HKJCPriority from 'assets/HKJCPriority.svg'
import { useCookies } from 'react-cookie'
import { adobeInteractionEvent } from 'utils/adobewa'

const HeaderContainer = styled.div`
    width: 100%;
    height: 110px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 88px;
    background-color: white;
`

const LeftHeaderSection = styled.div`
    display: flex;
    flex-direction: row;
`

const VerticalDivider = styled.div`
    width: 1px;
    margin: 2px 20px;
    background-color: #000;
`

const RightHeaderSection = styled.div``

const LanguageToggle = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 48px;
    height: 48px;
    border-radius: 24px;
    background-color: #dfd5bc;
    color: black;
    cursor: pointer;
`

interface CookieValues {
    name?: string
}

export default function Header() {
    const { i18n, t } = useTranslation('', { keyPrefix: 'header' })
    const [, setCookie] = useCookies<'weblang', CookieValues>(['weblang'])
    const locale = i18n.language

    const langButtonClick = () => {
        const locale = i18n.language
        const now = new Date()
        // Get the current day of the month
        const currentDay = now.getDate()
        // Add 7 days (one week) to the current day
        now.setDate(currentDay + 7)
        if (locale === 'en') {
            i18n.changeLanguage('zh')
            setCookie('weblang', 'zh', { expires: now })
        } else {
            i18n.changeLanguage('en')
            setCookie('weblang', 'en', { expires: now })
        }
    }

    const openOfficialSite = () => {
        adobeInteractionEvent({
            lang: locale,
            eventID: 'prioritysite_click_Header_HKJC',
        })
        if (locale === 'zh') {
            window.open('https://www.hkjc.com/zh-hk/index', '_blank')
        } else {
            window.open('https://www.hkjc.com/en-us/index', '_blank')
        }
    }

    return (
        <HeaderContainer>
            <LeftHeaderSection>
                <Image
                    src={HKJCLogo}
                    width={160}
                    height={65}
                    alt="HKJC Logo"
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                        openOfficialSite()
                    }}
                />
                <VerticalDivider />
                <Image
                    src={HKJCPriority}
                    width={132}
                    height={67}
                    alt="HKJC Logo"
                />
            </LeftHeaderSection>
            <RightHeaderSection>
                <LanguageToggle onClick={() => langButtonClick()}>
                    {t('langButtonText')}
                </LanguageToggle>
            </RightHeaderSection>
        </HeaderContainer>
    )
}
